import {HeaderSpecification} from "../../components/data-table/AdvancedTable";
import {BagAdvancedInsightsManager} from "../../stores/managers/BagAdvancedInsightsManager";
import ProfileStore from "../../stores/ProfileStore";
import {SynergyStore} from "../../stores/SynergyStore";
import {ExcelDataColumns} from "../../services/ApiTypes";


// TODO QA: Class re-definition inside the render loop?
class HeaderSpecificationWithOrdering {
    onOrder?: () => void;

    constructor(
        private readonly i: BagAdvancedInsightsManager,
        public label: string, public key: string,
        public type: 'string' | 'number' | 'currency' | '2_decimal' | 'category' | 'selection' | 'string[]',
        ordering_prefix: string,
        noOrdering?: boolean,
    ) {
        if (!noOrdering) {
            this.onOrder = () => {
                if (this.i.getOrderingWithPrefix(ordering_prefix) === key)
                    this.i.setOrderingWithPrefix('-' + key, ordering_prefix);
                else
                    this.i.setOrderingWithPrefix(key, ordering_prefix);
                return;
            }
        }
    }
}

export function OpportunityHeaders(i: BagAdvancedInsightsManager, showL4: boolean) {
    return ([
        new HeaderSpecificationWithOrdering(i, 'L1', 'active_l1', 'category', 'opportunity_'),
        new HeaderSpecificationWithOrdering(i, 'L2', 'active_l2', 'category', 'opportunity_'),
        new HeaderSpecificationWithOrdering(i, 'L3', 'active_l3', 'category', 'opportunity_'),
        showL4 ? new HeaderSpecificationWithOrdering(i, 'L4', 'active_l4', 'category', 'opportunity_') : undefined,
        new HeaderSpecificationWithOrdering(i, 'Opportunity rank', 'opportunity_rank', '2_decimal', 'opportunity_'),
        new HeaderSpecificationWithOrdering(i, 'Spend', 'spend', 'currency', 'opportunity_'),
    ] as (undefined | HeaderSpecification)[]).filter(v => v !== undefined) as HeaderSpecification[];
}

export function SupBreakdownHeaders(i: BagAdvancedInsightsManager, p: ProfileStore, showL4: boolean, hideParents: boolean, synergyStore: SynergyStore) {
    return ([
        hideParents ? undefined : new HeaderSpecificationWithOrdering(i, p.p.parentSupplierSynergyAltName ?? 'Parent Supplier', 'sp_name', 'string', 'sup_breakdown_'),
        new HeaderSpecificationWithOrdering(i, 'Supplier name', 's_name', 'string', 'sup_breakdown_'),
        p.p.showSupplierIdInAdvDashboard ? new HeaderSpecificationWithOrdering(i, 'Supplier id', 's_id', 'string', 'sup_breakdown_') : undefined,
        new HeaderSpecificationWithOrdering(i, 'Supplier country', 's_country_code', 'string', 'sup_breakdown_'),
        p.p.synergyDashboardShowBusinessUnits ? new HeaderSpecificationWithOrdering(i, 'Business Unit', 'business_units', 'string[]', 'sup_breakdown_', true) : undefined,
        p.p.synergyDashboardShowCDescriptionFilter ? new HeaderSpecificationWithOrdering(i, 'Company', 'c_description', 'string', 'sup_breakdown_') : undefined,
        new HeaderSpecificationWithOrdering(i, 'L1', 'active_l1', 'category', 'sup_breakdown_'),
        new HeaderSpecificationWithOrdering(i, 'L2', 'active_l2', 'category', 'sup_breakdown_'),
        new HeaderSpecificationWithOrdering(i, 'L3', 'active_l3', 'category', 'sup_breakdown_'),
        showL4 ? new HeaderSpecificationWithOrdering(i, 'L4', 'active_l4', 'category', 'sup_breakdown_') : undefined,
        (synergyStore.isSynergyDatabag && p.opportunitySplitAllowed) ? new HeaderSpecificationWithOrdering(i, 'Source', 'p_src_databag_id', 'string', 'opportunity_') : undefined,
        p.p.synergyDashboardShowDatabagName ? new HeaderSpecificationWithOrdering(i, 'Dataset name', 'databag_name', 'string', 'sup_breakdown_') : undefined,
        new HeaderSpecificationWithOrdering(i, synergyStore.isSynergyDatabag ? 'Supplier category spend' : 'Total spend', 'total_spend', 'currency', 'sup_breakdown_'),
        synergyStore.isSynergyDatabag ? new HeaderSpecificationWithOrdering(i, 'Total spend', 'parent_spend', 'currency', 'sup_breakdown_', undefined) : undefined,
    ] as (undefined | HeaderSpecification)[]).filter(v => v !== undefined) as HeaderSpecification[]
}

export function excelColumns(i: BagAdvancedInsightsManager, p: ProfileStore, showL4: boolean, hideParents: boolean, synergyStore: SynergyStore): ExcelDataColumns[] {
    const headers = SupBreakdownHeaders(i, p, showL4, hideParents, synergyStore);
    const excelColumns: ExcelDataColumns[] = headers
        .filter(h => h.key !== 'parent_spend' && h.key !== 'p_src_databag_id')
        .map(h => ({field: h.key, title: h.label}))

    // Include the download of all address information
    excelColumns.push(
        {model: 'data_source.supplier', field: 's_address', title: 'Supplier address'},
        {model: 'data_source.supplier', field: 's_postal', title: 'Supplier postal code'},
        {model: 'data_source.supplier', field: 's_city', title: 'Supplier city'},
        {model: 'data_source.supplier', field: 's_country', title: 'Supplier country'},
        {model: 'data_source.supplier', field: 's_region', title: 'Supplier region'},
    )

    return excelColumns;
}
